import React from 'react';
import { Link } from 'react-router-dom';
import Carousel from '../components/Carousel';
import ProductGrid from '../components/ProductGrid';

const Home = ({ products, carouselItems }) => {
  // 常用工具
  const popularTools = [
    {
      id: 'bracelet-calculator',
      name: '手链计算器',
      description: '筋围计算、咪数推荐、珠子计算',
      icon: '🧮',
      path: '/calculators/bracelet-calculator',
      color: 'from-blue-500 to-teal-500'
    },
    {
      id: 'cost-estimator',
      name: '材料成本估算器',
      description: '快速计算手链材料总成本',
      icon: '💰',
      path: '/calculators/cost-estimator',
      color: 'from-purple-500 to-pink-500'
    },
    {
      id: 'size-converter',
      name: '尺寸换算表',
      description: '厘米 ↔ 英寸 ↔ 法国尺码',
      icon: '📏',
      path: '/calculators/size-converter',
      color: 'from-green-500 to-emerald-500'
    },
    {
      id: 'qrcode-generator',
      name: '二维码生成',
      description: '生成手链信息二维码',
      icon: '📱',
      path: '/tools/qrcode-generator',
      color: 'from-indigo-500 to-purple-500'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-100 to-blue-100">
      {/* 轮播图 */}
      <Carousel items={carouselItems} />

      <div className="container mx-auto px-4 py-8">
        {/* 能量计算器入口 */}
        <div className="bg-white bg-opacity-90 rounded-xl shadow-lg p-6 mb-10 text-center">
          <h2 className="text-2xl font-bold mb-4 text-purple-800">
            能量计算器
          </h2>
          <p className="text-gray-600 mb-6">
            发现适合你的水晶，平衡五行能量
          </p>
          <Link
            to="/energy-calculator"
            className="px-8 py-3 bg-gradient-to-r from-purple-500 to-blue-500 text-white rounded-full hover:from-purple-600 hover:to-blue-600 transition-colors duration-200 font-medium"
          >
            开始测算
          </Link>
        </div>

        {/* 热门商品 */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold mb-6 text-center text-purple-800">
            热门商品
          </h2>
          <ProductGrid products={products.slice(0, 8)} />
        </section>



        {/* 工具功能 */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold mb-6 text-center text-purple-800">
            手链制作工具
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {popularTools.map((tool) => (
              <Link
                key={tool.id}
                to={tool.path}
                className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300 border border-purple-100 group"
              >
                <div className={`w-16 h-16 rounded-full bg-gradient-to-r ${tool.color} flex items-center justify-center text-white text-3xl mb-4 group-hover:scale-110 transition-transform duration-300 mx-auto`}>
                  {tool.icon}
                </div>
                <h3 className="text-xl font-semibold mb-2 text-purple-700 text-center">
                  {tool.name}
                </h3>
                <p className="text-gray-600 text-center">{tool.description}</p>
              </Link>
            ))}
          </div>
        </section>

        {/* 工具分类 */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold mb-6 text-center text-purple-800">
            工具分类
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4">
            <Link
              to="/calculators"
              className="bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-lg p-4 hover:from-purple-600 hover:to-pink-600 transition-colors duration-200 text-center font-medium"
            >
              🧮 计算器
            </Link>
            <Link
              to="/tutorials"
              className="bg-gradient-to-r from-orange-500 to-red-500 text-white rounded-lg p-4 hover:from-orange-600 hover:to-red-600 transition-colors duration-200 text-center font-medium"
            >
              📚 教程
            </Link>
            <Link
              to="/inspiration"
              className="bg-gradient-to-r from-blue-500 to-teal-500 text-white rounded-lg p-4 hover:from-blue-600 hover:to-teal-600 transition-colors duration-200 text-center font-medium"
            >
              🎨 灵感
            </Link>
            <Link
              to="/knowledge"
              className="bg-gradient-to-r from-green-500 to-emerald-500 text-white rounded-lg p-4 hover:from-green-600 hover:to-emerald-600 transition-colors duration-200 text-center font-medium"
            >
              📖 知识库
            </Link>
            <Link
              to="/tools"
              className="bg-gradient-to-r from-indigo-500 to-purple-500 text-white rounded-lg p-4 hover:from-indigo-600 hover:to-purple-600 transition-colors duration-200 text-center font-medium"
            >
              🔧 实用工具
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Home;